module.exports = __webpack_public_path__ + "img/icon-supervisor-flow.b453f2a7.png";